import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as core from '../../core'

export type RoomType = core.common.Identified<RoomType.Id> &
  core.common.Named &
  core.common.Described.Optionally &
  core.common.Coded & {
    category: RoomType.Category
  }

export namespace RoomType {
  export type Id = core.dms.data.Record.Id

  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  export enum Category {
    Standard = 'standard',
    Lab = 'lab',
    LabService = 'lab-service',
  }
  // Needs to be before namespace is defined
  const CATEGORIES: ReadonlySet<Category> = new Set(
    Object.values(Category) as Category[],
  )
  export namespace Category {
    const LABELS: Readonly<Record<Category, string>> = {
      [Category.Standard]: 'Standard',
      [Category.Lab]: 'Lab',
      [Category.LabService]: 'Lab Service',
    }

    export const ALL: readonly Category[] = Array.from(CATEGORIES)
    export const isCategory = TypeChecker.Factory.oneOf(CATEGORIES)
    export const assertIsCategory: TypeAsserter<Category> =
      TypeAsserter.Factory.from(isCategory)

    export const getLabel = (category: Category): string => LABELS[category]
  }

  export interface Filter {
    ids?: readonly RoomType.Id[]
  }
}
